import React from 'react'
import Policies from '../molecules/Policies/Policies'
import { useKeyboardControls } from '../../contexts/KeyboardControlsContext'
import { KeyboardControl, ControlHighlight } from '..//molecules/KeyboardControls'
import { HighlightEffect } from '../../enums/KeyboardControls'

export enum FocusableElement {
  FooterPolicies = 'footer-policies'
}

interface AccountDetailsFooterProps {
  isVisible: boolean
}

const AccountDetailsFooter: React.FC<AccountDetailsFooterProps> = ({
  isVisible
}) => {
  const keyboardControls = useKeyboardControls()

  // When not visible, don't render anything
  if (!isVisible) {
    return null
  }

  // When visible, render the footer with policies only
  return (
    <footer
      role='contentinfo'
      aria-label='Page footer'
      className='mt-auto pt-8 pb-8 px-8'
    >
      <div data-testid='policies-wrapper'>
        <KeyboardControl>
          <ControlHighlight
            active={keyboardControls.isEnabled && keyboardControls.isElementFocused(FocusableElement.FooterPolicies)}
            highlightEffect={HighlightEffect.ButtonHexOutline}
          >
            <Policies id={FocusableElement.FooterPolicies} />
          </ControlHighlight>
        </KeyboardControl>
      </div>
    </footer>
  )
}

export default AccountDetailsFooter
